import utils from '@/util/index'
import context from '@/main'

import {
  cloudRequest
} from '@/network/request'
let axios = cloudRequest()

/* 请求拦截器 */
axios.interceptors.request.use(config => {
  // 每次发送请求之前判断vuex中是否存在token
  // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
  // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
  // const token = window.localStorage.getItem("token");
  // token && (config.headers.Authorization = token);
  // config.baseURL = config.baseURL.replace('http:', 'https:')
  return config;
}, error => {
  return error;
})

/* 响应拦截器 */
axios.interceptors.response.use(function (response) { // ①10010 token过期（30天） ②10011 token无效
  // console.log(response);
  // if (response.headers['sessionstatus'] == 'timeout') {
  //     window.location.href = '/login';
  // }

  // console.log("response", response)
  //token无效时 重新登录
  if (response.data.state == 2 && response.data.code == '无效的token') {
    // utils.tips('error', '登录超时')
    // utils.removeSess("store");
    // utils.removeSess("loginMessage");
    // utils.removeSess("Authorazition");
    // utils.clearCookie("loginMessage");
    // utils.clearCookie("userId");
    // utils.clearCookie("Authorazition");
    // context.$store.commit("isLogin", false);
    // context.$store.commit("setUserId", "");
    // context.$store.commit("isLogin", false);
    // context.$store.commit("setUserId", "");
    // context.$router.push('/login')
  }

  return response
}, function (error) {
  return error
})

export function get(url, params = {}) {
  // params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
  return axios({
    method: 'get',
    url: url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'token': utils.getSess('loginMessage'),
      'Authorazition': utils.getSess('Authorazition')
    },
    params
  })
}

//第三方回调使用
export function get1(url, params = {}) {
  // params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
  return axios({
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'token': '',
      'Authorazition': ''
    },
    url: url,
    params
  })
}

//常用post请求  数据未JSON化
export function post(url, data) {
  return axios({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'token': utils.getSess('loginMessage'),
      'Authorazition': utils.getSess('Authorazition')
    },
    data: data,
  });


}

//put请求数据JSON化
export function put(url, data) {
  return axios({
    url: url,
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'token': utils.getSess('loginMessage'),
      'Authorazition': utils.getSess('Authorazition')
    },
    data: JSON.stringify(data)
  });
}

//数据未JSON化
export function put2(url, data) {
  return axios({
    url: url,
    method: 'put',
    headers: {
      'Content-Type': 'multipart/form-data',
      'token': utils.getSess('loginMessage'),
      'Authorazition': utils.getSess('Authorazition')
    },
    data: data
  });
}

export function deletes(url, data) {
  return axios({
    url: url,
    method: 'delete',
    headers: {
      // 'Content-Type': 'multipart/form-data',
      'token': utils.getSess('loginMessage'),
      'Authorazition': utils.getSess('Authorazition')
    },
    data: data
  });
}